import AMapLoader from '@amap/amap-jsapi-loader';

const install = (Vue) => {
	AMapLoader.load({
		"key": "46cb39d92c537b3b83da39e6da9e9f0e", // key
		"version": "1.4.15", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
		"plugins": ["AMap.MapType","AMap.ToolBar","AMap.Scale"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
		"AMapUI": { // 是否加载 AMapUI，缺省不加载
			"version": '1.1', // AMapUI 缺省 1.1
			"plugins": ['overlay/SimpleMarker'], // 需要加载的 AMapUI ui插件
		},
		// "Loca": { // 是否加载 Loca， 缺省不加载
		// 	"version": '1.3.2' // Loca 版本，缺省 1.3.2
		// },
	}).then((amap) => {
		Vue.prototype.$Amap = amap
		window.Amap = amap
	}).catch(err => {
		throw (new Error('加载高德地图失败：' + err))
	})
}

export default {
	install
}
